export const TEST_IDS = {
    containers: {
        employeeQuantityFields: 'establishmentData-employeeQuantityFields-container',
        anotherDataFields: 'establishmentData-anotherDataFields-container'
    },
    employeeQuantityFields: {
        ownAdministrativeWorkers: 'employeeQuantity-input-ownAdministrativeWorkers',
        ownProductionWorkers: 'employeeQuantity-input-ownProductionWorkers',
        eventualAdministrativeWorkers: 'employeeQuantity-input-eventualAdministrativeWorkers',
        eventualProductionWorkers: 'employeeQuantity-input-eventualProductionWorkers'
    },
    anotherDataFields: {
        hasSmokinPlaces: 'anotherData-input-hasSmokinPlaces',
        isSmokingAllowed: 'anotherData-input-isSmokingAllowed',
        observations: 'anotherData-input-observations'
    },
    buttons: {
        submit: 'main-button-submit',
        cancel: 'main-button-cancel'
    }
};
